import { constants } from "redux/constants/redux-constants";

export const set_selected_tab = (payload) => ({
  type: constants.SCRIBE.SELECTED_TAB,
  payload: payload,
});
export const set_show_popup = (payload, route) => ({
  type: constants.SCRIBE.SHOW_POPUP,
  payload: payload,
  route: route,
});
export const set_show_zoom_popup = (payload) => ({
  type: constants.SCRIBE.SHOW_ZOOM_POPUP,
  payload: payload,
});
export const set_selected_template = (payload) => ({
  type: constants.SCRIBE.SELECTED_TEMPLATE,
  payload: payload,
});
export const set_cdss_regen_object = (payload) => ({
  type: constants.SCRIBE.CDSS_REGEN_OBJ,
  payload: payload,
});
export const set_start_transcription_auto = (payload) => ({
  type: constants.SCRIBE.AUTO_START,
  payload: payload,
});
export const set_Subscription_Popup = (payload, resource) => ({
  type: constants?.SCRIBE?.SET_SUBSCRIPTION_POPUP,
  payload: payload,
  resource: resource,
});
export const set_exceeded_subscription_popup = (payload) => ({
  type: constants?.SCRIBE?.SET_EXCEEDED_SUBSCRIPTION_POPUP,
  payload: payload,
});
export const set_mobile_collapse = (payload) => ({
  type: constants?.SCRIBE?.SET_MOBILE_COLLAPSE,
  payload: payload,
});
export const set_persist_enc_id = (payload) => ({
  type: constants?.SCRIBE?.SET_PERSIST_ENC_ID,
  payload: payload,
});
export const set_jot_popup = (payload) => ({
  type: constants?.SCRIBE?.SHOW_JOT_POPUP,
  payload,
});
export const setRenderTabValue = (payload) => ({
  type: constants?.SCRIBE?.SET_RENDER_TAB_VALUE,
  payload,
});
export const set_current_events = (payload) => ({
  type: constants?.SCRIBE?.SET_CURRENT_EVENTS,
  payload,
});
export const set_CDSS_exists = (payload) => ({
  type: constants?.SCRIBE?.SET_CDSS_EXISTS,
  payload,
});
export const set_mic_clicked = (payload) => ({
  type: constants?.SCRIBE?.SET_MIC_CLICKED,
  payload,
});
